var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _dec21, _dec22, _dec23, _dec24, _dec25, _dec26, _dec27, _dec28, _dec29, _dec30, _dec31, _dec32, _dec33, _dec34, _dec35, _dec36, _dec37, _dec38, _dec39, _dec40, _dec41, _dec42, _dec43, _dec44, _dec45, _dec46, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12;

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

/*!
 * @copyright
 * Copyright(c) 2022 SICK AG
 */
import { Component, CustomElement, Event, html, Prop, State, Watch } from '@sick-davinci/ce-decorators';
import { numberComparator, numberGuard, NumberStepper } from '../_utils/number-utils';
import { defaultNumberConverter } from '../_utils/converter';
import { repeatOnLongPress } from '../_utils/pointer-input';
import { Button, Icon } from '..';
import { style } from './NumberInput.style';
/**
 * Number inputs for touch and desktop (classic).
 */

export let NumberInput = (_dec = Component({
  tag: 'davinci-number-input',
  style: [style],
  dependencies: [Button, Icon]
}), _dec2 = Prop({
  type: Boolean
}), _dec3 = Reflect.metadata("design:type", Boolean), _dec4 = Prop({
  type: Boolean
}), _dec5 = Reflect.metadata("design:type", Boolean), _dec6 = Prop({
  reflectAsAttribute: false
}), _dec7 = Reflect.metadata("design:type", Object), _dec8 = Prop({
  type: Boolean
}), _dec9 = Reflect.metadata("design:type", Boolean), _dec10 = Prop(), _dec11 = Reflect.metadata("design:type", String), _dec12 = Prop({
  reflectAsAttribute: false,
  comparator: numberComparator
}), _dec13 = Reflect.metadata("design:type", Number), _dec14 = Prop({
  reflectAsAttribute: false,
  comparator: numberComparator
}), _dec15 = Reflect.metadata("design:type", Number), _dec16 = Prop(), _dec17 = Reflect.metadata("design:type", String), _dec18 = Prop(), _dec19 = Reflect.metadata("design:type", String), _dec20 = Prop({
  reflectAsAttribute: false,
  type: Boolean
}), _dec21 = Reflect.metadata("design:type", Boolean), _dec22 = Prop({
  reflectAsAttribute: false
}), _dec23 = Reflect.metadata("design:type", String), _dec24 = Prop({
  type: Boolean
}), _dec25 = Reflect.metadata("design:type", Boolean), _dec26 = Prop({
  reflectAsAttribute: false,
  comparator: numberComparator
}), _dec27 = Reflect.metadata("design:type", Number), _dec28 = Prop({
  type: Boolean
}), _dec29 = Reflect.metadata("design:type", Boolean), _dec30 = Prop({
  reflectAsAttribute: false
}), _dec31 = Reflect.metadata("design:type", String), _dec32 = Prop({
  type: Boolean
}), _dec33 = Reflect.metadata("design:type", Boolean), _dec34 = Event(), _dec35 = Reflect.metadata("design:type", Object), _dec36 = Event(), _dec37 = Reflect.metadata("design:type", Object), _dec38 = State(), _dec39 = Reflect.metadata("design:type", Number), _dec40 = Watch('max'), _dec41 = Watch('min'), _dec42 = Watch('value'), _dec43 = Reflect.metadata("design:paramtypes", []), _dec44 = Watch('bare'), _dec45 = Watch('touch'), _dec46 = Reflect.metadata("design:paramtypes", []), _dec(_class = (_class2 = class NumberInput extends CustomElement {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "_bare", false);

    _initializerDefineProperty(this, "disabled", _descriptor, this);

    _initializerDefineProperty(this, "converter", _descriptor2, this);

    _initializerDefineProperty(this, "error", _descriptor3, this);

    _initializerDefineProperty(this, "label", _descriptor4, this);

    _initializerDefineProperty(this, "unitPrefix", _descriptor5, this);

    _initializerDefineProperty(this, "unitSuffix", _descriptor6, this);

    _defineProperty(this, "neutral", false);

    _initializerDefineProperty(this, "placeholder", _descriptor7, this);

    _initializerDefineProperty(this, "readonly", _descriptor8, this);

    _defineProperty(this, "_touch", false);

    _initializerDefineProperty(this, "warn", _descriptor9, this);

    _initializerDefineProperty(this, "change", _descriptor10, this);

    _initializerDefineProperty(this, "input", _descriptor11, this);

    _initializerDefineProperty(this, "_numericValue", _descriptor12, this);

    _defineProperty(this, "DECREASE_BUTTON_ID", 'decrease');

    _defineProperty(this, "INCREASE_BUTTON_ID", 'increase');

    _defineProperty(this, "INPUT_ID", 'input');

    _defineProperty(this, "_stepper", new NumberStepper());
  }

  /**
   *  Whether to show buttons that support incrementing and decrementing of the current value.
   *  The default is false.
   *  @default false.
   */
  get bare() {
    return this._bare;
  }

  set bare(v) {
    this._bare = v;

    if (v) {
      // enforce consistent visual expression when bare is set
      // bare has higher prio than touch
      this.removeAttribute('touch');
    }
  }

  /**
   * The greatest supported value.
   * The default (NaN) implies no limit at all.
   * @default NaN
   */
  get max() {
    return this._stepper.max;
  }

  set max(v) {
    this._stepper.max = v;
  }
  /**
   * The smallest supported value.
   * The default (NaN) implies no limit at all.
   * @default NaN
   */


  get min() {
    return this._stepper.min;
  }

  set min(v) {
    this._stepper.min = v;
  }
  /**
   * Unit prefix of the displayed value.
   * Styling from outside the shadow dom can be applied by using ::part(unit-prefix)
   */


  /**
   * Whether the value should not be aligned to the step-value when incremented or decremented.
   * @see step
   * @default false
   */
  get noStepAlign() {
    return !this._stepper.alignToStep;
  }

  set noStepAlign(v) {
    this._stepper.alignToStep = !v;
  }
  /**
   * A text that is displayed if the current value is an empty string.
   */


  /**
   * This is the value this element's current value is incremented or decremented by
   * when using the cursor-keys or its buttons.
   * @default 1
   */
  get step() {
    return this._stepper.step;
  }

  set step(v) {
    this._stepper.step = v;
  }
  /**
   * Toggles optimized rendering for touch-devices with other buttons.
   * Beware that {@link bare} overrides this property (has higher priority).
   * @default false
   */


  get touch() {
    return this._touch;
  }

  set touch(v) {
    // enforce consistent visual expression when bare is set
    // bare has higher prio than touch
    if (this.bare || !v) {
      this.removeAttribute('touch');
      this._touch = false;
    } else {
      this.setAttribute('touch', 'true');
      this._touch = true;
    }
  }

  /**
   * The value of this element.
   * The value is not formatted aka is a us-formatted number as a string.
   * Use {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/parseFloat|parseFloat} to turn the string into a number.
   */
  get value() {
    return isNaN(this._numericValue) ? '' : this._numericValue.toString();
  }

  set value(v) {
    // Do not(!) use this.converter here. The string must be parsed using parseFloat() which is exactly what numberGuard does for us.
    this._setValue(numberGuard(v));
  }
  /**
   * Whether visual hints for a warning-state are visible (true) or not (false).
   * @default false
   */


  // only used for styling
  _setValue(v) {
    this._numericValue = v; // manually set input value, because render-method can not always see the change (DAVIBE-494)

    const inputRef = this._getInputElement();

    if (inputRef) {
      inputRef.value = this.converter.toString(this._numericValue);
    }
  }
  /**
   *  The change-event is fired when an alteration to this element's value is committed by the user.
   *  @see input
   */


  _onNumericPropsChange() {
    this._setValue(this._stepper.applyTo(this._numericValue));
  }

  _onBooleanPropsChange() {
    // defer binding, so correct buttons are rendered before updating the handlers!
    window.requestAnimationFrame(() => {
      this._updateButtonEventHandlers();
    });
  } // Do not store a reference to the input-element but reduce state by retrieving the element when needed.


  _getInputElement() {
    var _this$shadowRoot;

    return (_this$shadowRoot = this.shadowRoot) === null || _this$shadowRoot === void 0 ? void 0 : _this$shadowRoot.querySelector(`input#${this.INPUT_ID}`);
  } // Do not store a reference to the decrease-button-element but reduce state by retrieving the element when needed.


  _getDecreaseButton() {
    var _this$shadowRoot2;

    return (_this$shadowRoot2 = this.shadowRoot) === null || _this$shadowRoot2 === void 0 ? void 0 : _this$shadowRoot2.querySelector(`#${this.DECREASE_BUTTON_ID}`);
  } // Do not store a reference to the increase-button-element but reduce state by retrieving the element when needed.


  _getIncreaseButton() {
    var _this$shadowRoot3;

    return (_this$shadowRoot3 = this.shadowRoot) === null || _this$shadowRoot3 === void 0 ? void 0 : _this$shadowRoot3.querySelector(`#${this.INCREASE_BUTTON_ID}`);
  }
  /**
   * Allow users to focus text fields
   * @example
   * ```javascript
   * document.querySelector('davinci-number-input').focus();
   * ```
   */


  focus() {
    const inputElm = this.shadowRoot.querySelector('input');

    if (inputElm) {
      inputElm.focus();
    }
  }

  componentFirstRender() {
    var _this$_getInputElemen;

    (_this$_getInputElemen = this._getInputElement()) === null || _this$_getInputElemen === void 0 ? void 0 : _this$_getInputElemen.addEventListener('keydown', event => {
      if (['ArrowDown', 'Down'].includes(event.key)) {
        event.preventDefault();

        this._decrease();
      }

      if (['ArrowUp', 'Up'].includes(event.key)) {
        event.preventDefault();

        this._increase();
      }
    });

    this._updateButtonEventHandlers();
  }

  render() {
    return html`${[html`<div class="column">${[this.label ? html`<label>${this.label}</label>` : '', html`<div class="row">${[this.touch ? this._renderTouchButtonDecrease() : '', this.unitPrefix ? html`<label for="input" class="unit prefix" part="unit-prefix">${this.unitPrefix}</label>` : '', this._renderInput(), this.unitSuffix ? html`<label for="input" class="unit suffix" part="unit-suffix">${this.unitSuffix}</label>` : '', this.touch ? this._renderTouchButtonIncrease() : html`
            <div class="buttons">${[this._renderClassicButtonIncrease(), this._renderClassicButtonDecrease()]}</div>`]}</div>`]}</div>`]}`;
  }

  _step(stepper, spinning = false) {
    if (this.disabled || this.readonly) {
      return;
    } // The native HTML input element treats the empty value as 0 and so do we.


    const inputValue = this.converter.toNumber(this._getInputElement().value);
    const oldValue = Number.isNaN(inputValue) ? 0.0 : inputValue;
    const newValue = stepper(oldValue);

    this._setValue(newValue);

    if (oldValue === newValue) {
      // may happen if oldValue === this.min/this.max
      return;
    }

    this.input.emit(this.value);

    if (!spinning) {
      this.change.emit(this.value);
    }
  }

  _decrease(spinning = false) {
    this._step(v => this._stepper.decrease(v), spinning);
  }

  _increase(spinning = false) {
    this._step(v => this._stepper.increase(v), spinning);
  }
  /**
   * Change event-handler for internal input element
   * @param e change-event from input element
   * @returns void
   */


  _onChange(e) {
    e.stopPropagation();
    const oldValue = this._numericValue;
    const newValue = this.converter.toNumber(e.target.value);

    this._setValue(newValue);

    if (oldValue === newValue) {
      return;
    }

    this.change.emit(this.value);
  }
  /**
   * Input event-handler for internal input element
   * @param e input event from input element
   */


  _onInput(e) {
    e.stopPropagation(); // Just pass the current value of the input-element along.
    // Do not(!) parse the value or do any other adjustments or
    // else the user won't be able to type correctly.

    this.input.emit(e.target.value);
  }
  /**
   * Render the native HTML input with formatted value and input/change event-handlers
   *
   * @example
   * ```html
   *   <davinci-number-input placeholder="info" label="classic"></davinci-number-input><br>
   *   <davinci-number-input warn label="warn" value="13"></davinci-number-input><br>
   *   <davinci-number-input disabled label="disabled" value="-13"></davinci-number-input><br>
   *   <davinci-number-input value="13" touch label="touch"></davinci-number-input><br>
   *   <davinci-number-input touch error placeholder="error" label="touch"></davinci-number-input><br>
   *   <davinci-number-input touch disabled label="touch" placeholder="disabled"></davinci-number-input><br>
   * ```
   *
   * @returns TemplateResult
   */


  _renderInput() {
    const formattedValue = isNaN(this._numericValue) ? '' : this.converter.toString(this._numericValue);
    return html`<input
      id="${this.INPUT_ID}"
      title="${formattedValue}"
      type="text"
      .value=${formattedValue}
      .placeholder="${this.placeholder ? this.placeholder : ''}"
      ?disabled="${this.disabled}"
      ?readonly="${this.readonly}"
      @change="${e => this._onChange(e)}"
      @input="${e => this._onInput(e)}"
    ></input>`;
  }

  _renderTouchButtonDecrease() {
    return this.bare ? html`` : html`<davinci-button
        icon="content/remove"
        id="${this.DECREASE_BUTTON_ID}"
        type="${this.neutral ? 'outline-neutral' : 'outline'}"
        .disabled="${this.disabled || this._numericValue <= this.min}"
      ></davinci-button>`;
  }

  _renderTouchButtonIncrease() {
    return this.bare ? html`` : html`<davinci-button
        icon="content/add"
        id="${this.INCREASE_BUTTON_ID}"
        type="${this.neutral ? 'outline-neutral' : 'outline'}"
        .disabled="${this.disabled || this._numericValue >= this.max}"
      ></davinci-button>`;
  }

  _renderClassicButtonDecrease() {
    return this.bare ? html`` : html`<button
        type="button"
        id="${this.DECREASE_BUTTON_ID}"
        .disabled="${this.disabled || this._numericValue <= this.min}"
      ><davinci-icon icon="navigation/expand_more"></davinci-icon></button>`;
  }

  _renderClassicButtonIncrease() {
    return this.bare ? html`` : html`<button
        type="button"
        id="${this.INCREASE_BUTTON_ID}"
        .disabled="${this.disabled || this._numericValue >= this.max}"
      ><davinci-icon icon="navigation/expand_less"></davinci-icon></button>`;
  }

  _updateButtonEventHandlers() {
    var _this$_removeLongPres;

    // remove all former listeners
    (_this$_removeLongPres = this._removeLongPressCallbacks) === null || _this$_removeLongPres === void 0 ? void 0 : _this$_removeLongPres.forEach(cb => cb());
    this._removeLongPressCallbacks = [];

    const decreaseButton = this._getDecreaseButton();

    const increaseButton = this._getIncreaseButton();

    if (decreaseButton && increaseButton) {
      // ensure we are attached to the dom
      this._removeLongPressCallbacks.push(repeatOnLongPress(decreaseButton, spinning => this._decrease(spinning), () => this.change.emit(this.value)));

      this._removeLongPressCallbacks.push(repeatOnLongPress(increaseButton, spinning => this._increase(spinning), () => this.change.emit(this.value)));
    }
  }

}, (_applyDecoratedDescriptor(_class2.prototype, "bare", [_dec2, _dec3], Object.getOwnPropertyDescriptor(_class2.prototype, "bare"), _class2.prototype), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "disabled", [_dec4, _dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "converter", [_dec6, _dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return defaultNumberConverter;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "error", [_dec8, _dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "label", [_dec10, _dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _applyDecoratedDescriptor(_class2.prototype, "max", [_dec12, _dec13], Object.getOwnPropertyDescriptor(_class2.prototype, "max"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "min", [_dec14, _dec15], Object.getOwnPropertyDescriptor(_class2.prototype, "min"), _class2.prototype), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "unitPrefix", [_dec16, _dec17], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "unitSuffix", [_dec18, _dec19], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _applyDecoratedDescriptor(_class2.prototype, "noStepAlign", [_dec20, _dec21], Object.getOwnPropertyDescriptor(_class2.prototype, "noStepAlign"), _class2.prototype), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "placeholder", [_dec22, _dec23], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, "readonly", [_dec24, _dec25], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class2.prototype, "step", [_dec26, _dec27], Object.getOwnPropertyDescriptor(_class2.prototype, "step"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "touch", [_dec28, _dec29], Object.getOwnPropertyDescriptor(_class2.prototype, "touch"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "value", [_dec30, _dec31], Object.getOwnPropertyDescriptor(_class2.prototype, "value"), _class2.prototype), _descriptor9 = _applyDecoratedDescriptor(_class2.prototype, "warn", [_dec32, _dec33], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class2.prototype, "change", [_dec34, _dec35], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class2.prototype, "input", [_dec36, _dec37], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class2.prototype, "_numericValue", [_dec38, _dec39], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return Number.NaN;
  }
}), _applyDecoratedDescriptor(_class2.prototype, "_onNumericPropsChange", [_dec40, _dec41, _dec42, _dec43], Object.getOwnPropertyDescriptor(_class2.prototype, "_onNumericPropsChange"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "_onBooleanPropsChange", [_dec44, _dec45, _dec46], Object.getOwnPropertyDescriptor(_class2.prototype, "_onBooleanPropsChange"), _class2.prototype)), _class2)) || _class);
